export default __webpack_public_path__ + "static/media/arrow_down_login.f56f8ef5.svg";